export default "__VITE_PUBLIC_ASSET__516e93b8__"